import React from 'react';
import Stepwizard from './stepwizard';
import { IConatinerProps } from './stepwizardinterface';
import { ICartContextType } from '../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface';
import { useCartContext } from '../../ShoppingCart/shoppingcart';

const StepWizardContainer = (props: IConatinerProps) => {
  const { stepperDetails }: ICartContextType = useCartContext();
  const { isShowPartOne, isShowPartTwo } = stepperDetails ?? {};

  const getDivRef = (ref: any, type: any) => {
    localStorage.setItem(type, ref?.current?.offsetTop ?? 0)
  }

  const scrollToDiv = (type: any) => {
    const offsetTop: any = Number(localStorage.getItem(type));
    const height = type === 'fulfillmentDiv' ? 0 : 200;
    const additionalHeight = (isShowPartOne && isShowPartTwo && type !== 'fulfillmentDiv' && type !== 'paymentDiv') ? 200 : 0;
    const yOffset = offsetTop + height + additionalHeight;
    window.scrollTo({ top: yOffset, behavior: 'smooth' });
  };
  return (
      <Stepwizard scrollToDiv={scrollToDiv}
          getDivRef={getDivRef}
          updateStepperDetails={props?.updateStepperDetails} itemSummaryDetails={props.itemSummaryDetails}
          getAvailablePartsDetails={props?.getAvailablePartsDetails}
          getIsNextDisableStatus={props?.getIsNextDisableStatus}
          availabilityDetails={props?.availabilityDetails} getAvailabilityDetails={props?.getAvailabilityDetails}
          fulfillmentDetailRes={props?.fulfillmentDetailRes} cartsDetails={props.cartsDetails}
          formWizardRef={props.formWizardRef} setActive={props.setActive}
          phoneCodeOption={props.phoneCodeOption}
          shoppingcartOnClick={props.shoppingcartOnClick}
          getItemSummaryDetailsWithoutLoading={props.getItemSummaryDetailsWithoutLoading}
          saveFulfillmentType={props.saveFulfillmentType}
          isNextClick={props?.isNextClick}
          isPromoChanges={props.isPromoChanges}
          setIsServiceTypeRequired={props?.setIsServiceTypeRequired}
      />
  )
}

export default StepWizardContainer
